import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { PCB_PRE_LAYOUT } from '@/constants/treeConstants';
import { savePreLayoutSetting, createPreLayoutInterface } from '../../store/prelayout/action';
import { PreLayoutSetting } from '@/services/Sierra/prelayout';
import PreLayoutSettingPanel from './settingPanel';
import getIcon from '@/services/helper/iconHelper';
import { topBarResize } from '@/services/helper/topBarResize';
import './index.css';

const SETTING = "Settings",
  CREATE = "Create";

class TopBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: {
        prelayoutSetting: false,
      }
    }
  }

  componentDidMount = () => {
    this._changeTopBarSize()
    this.screenChange();
  }

  componentDidUpdate = (prevProps) => {
    const { currentProjectId, viewList, preLayoutId, firstOpen } = this.props;
    const { visible } = this.state;

    if (currentProjectId !== prevProps.currentProjectId || (prevProps.viewList.includes(PCB_PRE_LAYOUT) && !viewList.includes(PCB_PRE_LAYOUT))) {
      this.setState({
        visible: {
          ...visible,
          prelayoutSetting: false,
        }
      })
    }

    if ((preLayoutId !== prevProps.preLayoutId)) {
      this.setState({
        visible: {
          ...visible,
          prelayoutSetting: visible.prelayoutSetting === 'first' ? 'first' : false
        }
      })
    }

    if (preLayoutId && firstOpen && firstOpen !== prevProps.firstOpen) {
      this.setState({
        visible: {
          ...visible,
          prelayoutSetting: 'first'
        }
      })
    }
  }

  screenChange() {
    window.addEventListener('resize', this._changeTopBarSize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._changeTopBarSize);
  }

  _changeTopBarSize = () => {
    topBarResize('sierra-pre-layout-top-bar', 200);
  }

  createPreLayoutInterface = (e) => {
    e && e.stopPropagation();
    const { create } = this.props;
    if (create) {
      return;
    }
    this.props.createPreLayoutInterface()
  }

  openPreLayoutSetting = (boolean) => {
    this.setState({
      visible: {
        ...this.state.visible,
        prelayoutSetting: boolean,
      }
    })
  }

  getTopMenuList = () => {
    const { viewList, create } = this.props;
    const isPreLayout = viewList.includes(PCB_PRE_LAYOUT);

    if (isPreLayout) {
      return [{ title: CREATE, enabled: true, onClick: this.createPreLayoutInterface, iconType: create ? "loading" : "play-circle" },
      { title: SETTING, iconType: "setting", onClick: () => this.openPreLayoutSetting(true), enabled: true }]
    }
    return []
  }

  topItem = (item) => {
    const { enabled, onClick, iconType, title, iconClassName } = item;

    const Icon = getIcon(iconType);
    return (
      <div
        className={enabled ? 'sierra-top-bar-item' : 'sierra-top-bar-item sierra-top-bar-item-disabled'}
        onClick={enabled ? (e) => onClick(e) : null}
        key={item.title}
        title={title}
      >
        {iconType ? <Icon /> : iconClassName ? <span className={iconClassName} /> : null}
        <span className='sierra-top-bar-item-title'>{title}</span>
      </div>
    );
  }

  render() {
    const { preLayoutName, preLayoutSetting } = this.props;
    const { visible } = this.state;
    const topMenu = this.getTopMenuList();

    return (
      <Fragment>
        <div id='sierra-pre-layout-top-bar'>
          {topMenu.map(item => {
            switch (item.title) {
              default: return this.topItem(item);
            }
          })}
        </div>
        {
          visible['prelayoutSetting'] && <PreLayoutSettingPanel
            {...preLayoutSetting}
            name={preLayoutName}
            closeModal={() => this.openPreLayoutSetting(false)}
            savePreLayout={this.props.savePreLayoutSetting}
          />
        }
      </Fragment>
    )
  }
}

const mapState = (state) => {
  const { SierraReducer: {
    project: { currentProjectId, layout, viewList },
    prelayout: { id: preLayoutId, name: preLayoutName, firstOpen, create, ...data },
  } } = state;

  const preLayoutSetting = new PreLayoutSetting(data)
  return {
    currentProjectId,
    layout,
    viewList,
    preLayoutId,
    preLayoutName,
    preLayoutSetting,
    firstOpen,
    create
  }
}

const mapDispatch = (dispatch) => ({
  savePreLayoutSetting(name, params) {
    dispatch(savePreLayoutSetting(name, params))
  },
  createPreLayoutInterface() {
    dispatch(createPreLayoutInterface())
  },
});

export default connect(mapState, mapDispatch)(TopBar)